import { render, staticRenderFns } from "./BLLightbox.vue?vue&type=template&id=baf42d3a&scoped=true&lang=pug&"
import script from "./BLLightbox.vue?vue&type=script&lang=js&"
export * from "./BLLightbox.vue?vue&type=script&lang=js&"
import style0 from "./BLLightbox.vue?vue&type=style&index=0&id=baf42d3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf42d3a",
  null
  
)

export default component.exports